import { ActionTypes } from '../../actions/ActionTypes';
import { IObjectStateModel, DefaultObjectState } from '../../models/StateModels';
import { IPropAction } from '../../models/ActionModels';
import ReducerFunctions from './ReducerFunctions';

export default (actionSubType: string) => (
  state: IObjectStateModel = DefaultObjectState,
  action: IPropAction<Object>
): IObjectStateModel => {
  switch (action.type) {
    case ActionTypes.PAGE_LOADED:
      if (action.subtype === actionSubType)
        return ReducerFunctions.page_loaded_state(state, action);
      break;
    case ActionTypes.PAGE_UNLOADED:
      if (action.subtype === actionSubType)
        return ReducerFunctions.page_unloaded_state(state, action);
      break;
    case ActionTypes.PAGE_PROPS_SENT:
      if (action.subtype === actionSubType) return ReducerFunctions.page_props_sent(state, action);
      break;
    default:
      return state;
  }

  return state;
};
